<template>
<div class="row justify-content-md-center">

	<div class="col-12 col-xl-8">

		<div class="row">
			<div class="col">

				<b-form-group class="pull-right">
					<b-btn variant="primary"
					       v-b-tooltip.hover
					       title="Veiling toevoegen"
					       exact
					       :to="{ name: 'auctionAdd' }">
						<i class="fa fa-fw fa-plus"></i>
					</b-btn>
					<b-btn variant="outline-secondary"
					       v-b-tooltip.hover
					       title="Terug"
					       exact
					       :to="{ name: 'Landingpage' }">
						<i class="fa fa-fw fa-reply"></i>
					</b-btn>
				</b-form-group>

				<h1 class="display-4">Veilingen beheer</h1>

				<b-alert v-if="error"
				         variant="danger"
				         show>{{ error }}</b-alert>

				<b-pagination-nav v-if="auctions.last_page" :link-gen="linkGen"
				                  :number-of-pages="auctions.last_page"
				                  :value="auctions.current_page"
				                  use-router
				                  align="right" />
			</div>
		</div>


		<partial-loader :loading="isFetching"></partial-loader>

		<b-table v-show="!isFetching"
				 
		         striped
		         hover
		         show-empty
		         :items="auctions.data"
		         :fields="fields"
		         :per-page="parseInt(auctions.per_page)"
		         :sort-by.sync="sortBy"
		         :sort-desc.sync="sortDesc"
		         :busy="isFetching"
		         :empty-text="$t('auction.listEmptyText')"
		         :empty-filtered-text="$t('auction.listEmptyFilteredText')">

			<template v-slot:cell(start)="row">
 	 			{{ row.item.start | formatDate('DD-MM-YYYY') }}
 	 		</template>

			<template v-slot:cell(end)="row">
 	 			{{ row.item.end | formatDate('DD-MM-YYYY') }}
 	 		</template>

			<template v-slot:cell(actions)="row">
	 			<b-btn-group class="pull-right">
					<b-btn variant="outline-danger" @click="showDeleteModal(row.item)"><i class="fa fa-fw fa-trash"></i></b-btn>
					<b-btn variant="outline-primary" :to="{ name: 'auction', params: { auctionId: row.item.id } }"><i class="fa fa-fw fa-eye"></i></b-btn>
					<b-btn variant="outline-primary" :to="{ name: 'auctionEdit', params: { auctionId: row.item.id } }"><i class="fa fa-fw fa-edit"></i></b-btn>
				</b-btn-group>
	 		</template>

		</b-table>

		<b-pagination-nav :link-gen="linkGen"
		                  :number-of-pages="auctions.last_page"
		                  :value="auctions.current_page"
		                  use-router
		                  align="right" />

		<delete-dialog-modal ref="deleteModal"
		                     :delete-name="selectedDeleteAuctionName"
		                     :item="selectedDeleteAuction"
		                     :isDeleting="isDeleting"
		                     @confirm="deleteAuction"></delete-dialog-modal>
	</div>
</div>
</template>

<script>
import { isNil } from 'lodash';
import AuctionService from '@/services/auction-service.js';
import PartialLoader from '@/components/elements/PartialLoader';
import DeleteDialogModal from '@/components/elements/Edit/DeleteDialogModal';
import { flashSuccess } from '@/helpers/flash-message-helper';
import { formatDate } from '@/filters/date-filters';

export default {
	components: {
		PartialLoader,
		DeleteDialogModal
	},
	filters: {
		formatDate
	},
	data() {
		return {
			isFetching: true,
			isDeleting: false,
			auctions: {},
			error: null,
			fields: [
				{ key: 'id', label: 'Id' },
				{ key: 'start', label: 'Start datum' },
				{ key: 'end', label: 'Eind datum' },
				{ key: 'title', label: 'Naam' },
				{ key: 'abbreviation', label: 'Afkorting' },
				{ key: 'actions', label: 'Acties' }
			],
			currentPage: 1,
			sortBy: 'id',
			sortDesc: true,
			selectedDeleteAuction: null
		}

	},
	computed: {
		selectedDeleteAuctionName() {
			if (!this.selectedDeleteAuction) return '';

			return 'de veiling ' + this.selectedDeleteAuction.title;
		}
	},
	watch: {
		'$route': 'fetchAuctions'
	},
	methods: {
		initialize() {
			this.fetchAuctions();
		},
		linkGen(pageNumber) {
			return '?page=' + pageNumber;
		},
		fetchAuctions() {
			this.isFetching = true;

			const query = this.$route.query;
			const currentPage = Number.parseInt(query.page);
			this.currentPage = isNaN(currentPage) ? 1 : currentPage;

			const params = {
				page: this.currentPage,
				sort: this.sortBy,
				order: this.sortDesc ? 'desc' : 'asc'
			}

			return AuctionService.getAll(params).then(response => {
				this.isFetching = false;
				this.auctions = response;
			}).catch(error => {
				this.isFetching = false;
				this.error = error.message;
			});
		},
		/**
		 * Show delete modal for the auction
		 * @param  {Object} auction
		 */
		showDeleteModal(auction) {
			this.selectedDeleteAuction = auction;
			this.$refs.deleteModal.show();
		},
		deleteAuction(auction) {
			this.isDeleting = true;
			return AuctionService.delete(auction.id).then(response => {
				this.$refs.deleteModal.hide()
				this.isFetching = false;
				this.isDeleting = false;
				flashSuccess(this.$t('auction.deleteSuccess'));
				this.fetchAuctions();
			}).catch(error => {
				this.$refs.deleteModal.hide()
				this.isFetching = false;
				this.isDeleting = false;
				this.error = error.message;
			});
		}
	},
	mounted() {
		this.initialize();
	}
}
</script>



// WEBPACK FOOTER //
// AuctionList.vue?1c5a1597